module.exports = __webpack_public_path__ + "img/shape-cyan.c34d5e89.svg";